module.exports = __webpack_public_path__ + "static/media/header_news.d36b5db5.png";